import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import BlogDetail from "@/views/Blog/Detail/Detail.vue";
import PageNotFound from '@/views/Errors/PageNotFound/PageNotFound.vue';
Vue.use(Router);
Vue.use(Meta);
export default new Router({
    /* mode: process.env.ROUTER_MODE,*/
    mode: "history",
    routes: [
        { path: '/', name: 'Home', component: () => import(/* webpackChunkName: "home" */ '@/views/Home/Home.vue') },
        { path: '/leistungen', name: 'Services', component: () => import(/* webpackChunkName: "services" */ '@/views/Services/Services.vue') },
        { path: '/kontakt', name: 'Contact', component: () => import(/* webpackChunkName: "contact" */ '@/views/Contact/Contact.vue') },
        { path: '/datenschutz', name: 'Privacy', component: () => import(/* webpackChunkName: "privacy" */ '@/views/Privacy/Privacy.vue') },
        { path: '/impressum', name: 'Imprint', component: () => import(/* webpackChunkName: "imprint" */ '@/views/Contact/Contact.vue') },
        //{path: '/blog', name: 'Blog', component: Blog, meta: { bodyClass: 'blog' }},
        { path: '/blog/:id/:slug', name: 'BlogDetail', component: BlogDetail },
        { path: '/arbeiten', name: 'Works', component: () => import(/* webpackChunkName: "works" */ '@/views/Works/Works.vue') },
        { path: '/arbeiten/studentenwerk-karlsruhe', name: 'studentenwerk-karlsruhe', component: () => import(/* webpackChunkName: "studentenwerk-karlsruhe"*/ '@/views/References/studentenwerk-karlsruhe/StudentenwerkKarlsruhe.vue') },
        { path: '/arbeiten/visual-vest', name: 'visual-vest', component: () => import(/* webpackChunkName: "visual-vest" */ '@/views/References/visual-vest/VisualVest.vue') },
        { path: '/arbeiten/baxter', name: 'baxter', component: () => import(/* webpackChunkName: "baxter" */ '@/views/References/baxter/Baxter.vue') },
        { path: '/arbeiten/falk', name: 'falk', component: () => import(/* webpackChunkName: "falk" */ '@/views/References/falk/Falk.vue') },
        { path: '/arbeiten/pepperl-fuchs', name: 'pepperl-fuchs', component: () => import(/* webpackChunkName: "pepperl-fuchs" */ '@/views/References/pepperl-fuchs/PepperlFuchs.vue') },
        { path: '/arbeiten/wir-teilen-alles', name: 'pfizer', component: () => import(/* webpackChunkName: "wir-teilen-alles" */ '@/views/References/pfizer/Pfizer.vue') },
        { path: '/arbeiten/pfalzwerke-vida', name: 'vida', component: () => import(/* webpackChunkName: "pfalzwerke-vida" */ '@/views/References/vida/Vida.vue') },
        { path: '/arbeiten/shire', name: 'shire', component: () => import(/* webpackChunkName: "shire" */ '@/views/References/shire/Shire.vue') },
        { path: "*", name: 'Error404', component: PageNotFound, meta: { bodyClass: 'error error-404' } }
    ]
});



//////////////////
// WEBPACK FOOTER
// ./src/router/index.ts
// module id = null
// module chunks = 